import { Injectable } from '@angular/core';
import { GatewayAPIService } from '../../core/gateway-api.service';

@Injectable({
  providedIn: 'root',
})
export class ExternalProcessorService {
  constructor(private api: GatewayAPIService) {}

  /**
   * This method looks up merchants associated with a user or impersonated user
   * based on the claims associated with the request.
   * Nothing needs to be explicitly passed in.
   */
  // TODO (jacob): How are we handling errors returned from the API?
  public sync(): Promise<void | any> {
    return this.api.apiCallSane(
      '/gateway/sync',
      'GET',
      this.api.getDefaultHeaders(),
      null,
      null,
    );
  }
}
